<template>
  <div class="oct-salon-customer-list">
    <div class="oct-salon-customer-list__container">
      <div class="oct-salon-customer-list__header oct-salon-customer-list__row">
        <div class="oct-salon-customer-list__col">
          &nbsp;
        </div>

        <div class="oct-salon-customer-list__col">
          氏名
        </div>

        <div class="oct-salon-customer-list__col">
          スタイリスト名
        </div>

        <div class="oct-salon-customer-list__col">
          最終来店日
        </div>

        <div class="oct-salon-customer-list__col">
          購入歴
        </div>

        <div class="oct-salon-customer-list__col">
          売上
        </div>

        <div class="oct-salon-customer-list__col">
          送信
        </div>

        <div class="oct-salon-customer-list__col">
          閲覧
        </div>

        <div class="oct-salon-customer-list__col">
          ♥
        </div>

        <div class="oct-salon-customer-list__col">
          カート
        </div>

        <div class="oct-salon-customer-list__col">
          購入
        </div>
      </div>

      <div class="oct-salon-customer-list__item">
        <div class="oct-salon-customer-list__row">
          <div class="oct-salon-customer-list__col">
            <oct-icon
              icon="plus"
              class="oct-salon-customer-list__handle"
            />
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              シャーロット・デイヴィス
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              シャーロット・デイヴィス
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            2025/12/30
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__icon">
              購入済
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              ¥694,740
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              336
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              2
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              1
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              1
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              1
            </span>
          </div>
        </div>

        <div class="oct-salon-customer-list__row">
          <div class="oct-salon-customer-list__col">
            &nbsp;
          </div>

          <div class="oct-salon-customer-list__col">
            &nbsp;
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              阿久津穂乃果
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            2025/12/30
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__icon oct-salon-customer-list__icon--outlined">
              未購入
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              -
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__text">
              -
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__icon oct-salon-customer-list__icon--outlined">
              -
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__icon oct-salon-customer-list__icon--outlined">
              -
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__icon oct-salon-customer-list__icon--outlined">
              -
            </span>
          </div>

          <div class="oct-salon-customer-list__col">
            <span class="oct-salon-customer-list__icon oct-salon-customer-list__icon--outlined">
              -
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OctIcon from '@/components/icon/OctIcon.vue';

export default {
  name: 'OctSalonCustomerList',
  components: {
    OctIcon
  },
  props: {
  },
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-salon-customer-list__container {
  width: 100%;
  overflow-x: auto;
}

.oct-salon-customer-list__row {
  display: grid;
  grid-template-columns: oct-rem(16)  oct-rem(144) oct-rem(144) oct-rem(120) oct-rem(72) oct-rem(96) minmax(oct-rem(72), 1fr) minmax(oct-rem(72), 1fr) minmax(oct-rem(72), 1fr) minmax(oct-rem(72), 1fr) minmax(oct-rem(72), 1fr);
  gap: oct-rem(32);
  width: max-content;
  padding: 0 oct-rem(32);
  background-color: $oct-theme--neutral-10;
  border-top: oct-rem(1) solid $oct-theme--neutral-20;

  &:first-child {
    background-color: transparent;
  }
}

.oct-salon-customer-list__header {
  border-top-width: 0;
}

.oct-salon-customer-list__col {
  font-size: oct-rem(14);
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: oct-rem(48);
  overflow: hidden;

  .oct-salon-customer-list__header & {
    font-size: oct-rem(12);
    color: $oct-theme--neutral-50;
  }
}

.oct-salon-customer-list__text {
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
}

.oct-salon-customer-list__icon {
  font-size: oct-rem(10);
  color: $oct-theme--on-primary;
  line-height: 1;
  display: flex;
  justify-content: center;
  padding: oct-rem(8);
  background-color: $oct-theme--primary;
  border-radius: oct-rem(13);
  min-width: oct-rem(36);

  &--outlined {
    color: $oct-theme--neutral-30;
    padding: oct-rem(7);
    background-color: transparent;
    border: oct-rem(1) solid $oct-theme--neutral-30;
  }
}

.oct-salon-customer-list__handle {
  display: block;
  width: oct-rem(16);
  height: oct-rem(16);
}
</style>
